import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import {
  useFillsPaginatedQuery,
  PAGE_LIMIT,
} from 'api/queries/fillPaginatedQueries';
import MetaTags from 'components/layout/header/MetaTags';
import { MarketSearchDropdown } from 'components/markets/MarketSearchDropdown';
import OrderDetailScreen from 'components/orders/detail/OrderDetailScreen';
import DownloadTradesCSV from 'components/trading/MyTrades/DownloadTradesCSV';
import MyTradeHistoryMultiMarket from 'components/trading/MyTrades/MyTradeHistoryMultiMarket';
import WalletDashboardContent from 'components/wallet/dashboard/WalletDashboardContent';
import { useNavigateToPrevious } from 'lib/redirect';
import { useSelector } from 'reduxState/store';

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

function TradeHistoryPage() {
  const isMobile = useSelector(state => state.screen.isMobile);
  const navigateToPrevious = useNavigateToPrevious('/wallet/history/trades');
  const [searchMarket, setSearchMarket] = useState('');
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  const [page, setPage] = useState(1);

  const {
    data,
    isLoading,
    isPlaceholderData: isPreviousData,
  } = useFillsPaginatedQuery({
    isVault: false,
    page,
    searchMarket,
    walletAddress,
  });

  const fills = data?.items;

  const onChangeSearchMarket = (market: string) => {
    setPage(1);
    setSearchMarket(market);
  };

  // TODO: is this safe ? maybe we can check if it's format of correct ID (or length at min)
  const { orderUuid: activeDetailOrderUuid, fillId: activeDetailOrderFillId } =
    useParams<{ orderUuid?: string; fillId?: string }>();

  const detailScreen = activeDetailOrderUuid ? (
    <OrderDetailScreen
      orderUuid={activeDetailOrderUuid}
      highlightedFillId={activeDetailOrderFillId}
      showingOn="trade-history"
      onClose={navigateToPrevious}
    />
  ) : null;

  const disabledControls = !fills?.length && !searchMarket;

  return isMobile && detailScreen ? (
    <>{detailScreen}</>
  ) : (
    <>
      {!isMobile && detailScreen && <>{detailScreen}</>}

      <MetaTags title="Trade History" />

      <WalletDashboardContent
        title="Trade History"
        showBalanceActions
        headerContentRight={
          isMobile ? (
            <DownloadTradesCSV disabled={disabledControls} />
          ) : (
            <Flex>
              <div style={{ padding: '0 16px 0 12px' }}>
                <DownloadTradesCSV disabled={disabledControls} />
              </div>
              <MarketSearchDropdown
                selectedMarket={searchMarket}
                onSelect={onChangeSearchMarket}
                disabled={disabledControls}
              />
            </Flex>
          )
        }
        headerContentMiddle={
          isMobile ? (
            <div style={{ padding: '0 0 12px 0' }}>
              <MarketSearchDropdown
                selectedMarket={searchMarket}
                onSelect={onChangeSearchMarket}
                disabled={disabledControls}
              />
            </div>
          ) : undefined
        }
      >
        <MyTradeHistoryMultiMarket
          fills={fills || []}
          onChangePage={setPage}
          page={page}
          isLoading={isLoading}
          isPreviousData={isPreviousData}
          totalCount={data?.count}
          pageLimit={PAGE_LIMIT}
        />
      </WalletDashboardContent>
    </>
  );
}

export default TradeHistoryPage;
